export const APPLICATION_DECLINE_REASONS = [
  {
    label: 'incorrectlyFilled',
    value: 'Неверно заполнена',
  },
];
